module.exports = __webpack_public_path__ + "img/mall_img2.2a9666e7.png";